import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsfScheduleApiMeta } from "../apiMeta";
import {
  type ScheduledRoutesInput,
  scheduledRoutesInputSchema,
} from "./shared/scheduledRoutes.input";
import {
  type SchedRoute,
  schedRouteSchema,
} from "./shared/scheduledRoutes.output";

/**
 * Metadata for the fetchScheduledRoutes endpoint
 */
export const scheduledRoutesMeta = {
  functionName: "fetchScheduledRoutes",
  endpoint: "/schedroutes",
  inputSchema: scheduledRoutesInputSchema,
  outputSchema: schedRouteSchema.array(),
  sampleParams: {},
  endpointDescription:
    "List all scheduled routes across current and upcoming seasons.",
} satisfies EndpointMeta<ScheduledRoutesInput, SchedRoute[]>;

/**
 * Fetch function for retrieving all scheduled routes across current and upcoming seasons
 */
const { fetch, useHook } = createFetchAndHook<
  ScheduledRoutesInput,
  SchedRoute[]
>({
  api: wsfScheduleApiMeta,
  endpoint: scheduledRoutesMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/scheduledRoutes.endpoints").scheduledRoutesGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving all scheduled routes across current and upcoming seasons
 */
export const fetchScheduledRoutes: FetchFactory<
  ScheduledRoutesInput,
  SchedRoute[]
> = fetch;

/**
 * React Query hook for retrieving all scheduled routes across current and upcoming seasons
 */
export const useScheduledRoutes: HookFactory<
  ScheduledRoutesInput,
  SchedRoute[]
> = useHook;
